var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(241, 242, 243)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "214px",
    height: "214px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#0099e5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-1.4652014652014653s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.692307692307693 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#ff4c4c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-1.3431013431013432s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461539 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#34bf49"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-1.221001221001221s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.07692307692308 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#0099e5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-1.098901098901099s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923077 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#ff4c4c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.9768009768009769s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153845 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#34bf49"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.8547008547008548s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.15384615384616 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#0099e5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.7326007326007327s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#ff4c4c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.6105006105006106s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846155 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#34bf49"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.48840048840048844s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#0099e5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.36630036630036633s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.9230769230769 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#ff4c4c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.24420024420024422s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.61538461538464 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#34bf49"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "-0.12210012210012211s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    rx: 2,
    ry: 6,
    width: 4,
    height: 12,
    fill: "#0099e5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.5873015873015872s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.fb764b0dfa4354bd47b8c2605b27c710.svg";
export { ForwardRef as ReactComponent };